import { useVacancyModerationBadgeCountQuery } from 'src/entities/vacancy';
import { useSoundOnUnreadIncrease } from 'src/shared/notification';
import { useVacancyModerationRealtime } from './useVacancyModerationRealtime';

export const useVacancyModerationNotifications = (): void => {
  const { count, isReady } = useVacancyModerationBadgeCountQuery();

  useVacancyModerationRealtime();
  useSoundOnUnreadIncrease(count, isReady);
};
